import { clearInterval, setInterval } from "timers";

export interface IDisposable {
    dispose(): void;
}

export function disposableInterval(callback: (...a: any[]) => void, ms: number, ...args: any[]): IDisposable {
    const handle = setInterval(callback, ms, args);
    return {dispose: () => clearInterval(handle)} as IDisposable;
}
